<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { decryptDes, getSessionId, setSessionId, setUid } from '@/util/util.js'
export default {
  name: 'App',
  data () {
    return {
      isApp: true,
      passApp: this.$route.name === 'Share',
      paramError: false,
      paramErrCode: 0
    }
  },
  mounted () {
    this.initCNZZ()
  },
  created () {
    // window.weCallback = (code, msg, requestCode) => {
    //   this.weCallback(code, msg, requestCode)
    // }
    if (!this.isApp || this.passApp) {
      return
    }
    let sessionId = getSessionId()
    // let sessionId = '315705df763644a56139bd31e4e2effc'
    // setSessionId(sessionId)
    // if ((!this.$store.state.userInfo || !sessionId) && window.weBridge && window.weBridge.getLocalUser) {
    //   window.weBridge.getLocalUser(1)
    // }
  },
  methods: {
    initCNZZ () {
      // 添加脚本
      const script = document.createElement('script')
      script.src = 'https://s9.cnzz.com/z_stat.php?id=1278115036&web_id=1278115036'
      script.language = 'JavaScript'
      script.id = 'cnzz'
      document.body.appendChild(script)
    },
    isLimitAct () {
      return new Date(this.$store.state.limitTime).getTime() < new Date().getTime()
    },
    
    weCallback (code, msg, requestCode) {
      if (requestCode === 1) {
        if (code !== 0) {
          this.paramErrCode = code
          this.paramError = true
        } else {
          let json = JSON.parse(msg)
          // this.$store.state.userInfo = json
          this.$store.commit('setLoginAccount', json)
          let uid = json.uid
          if (uid) {
            setUid(uid)
          }
          let token = decryptDes(json.token, 'sd09k.jh')
          if (token) {
            setSessionId(token.split(',')[0])
          }
        }
      }
      this.$children.forEach(item => {
        item.$emit('dispatchCallback', code, msg, requestCode)
      })
    }
  },
  watch: {
    '$route' () {
      if (window._czc) {
        // 监听路由变化
        let location = window.location
        let contentUrl = location.pathname + location.hash
        let refererUrl = '/'
        window._czc.push(['_trackPageview', contentUrl, refererUrl])
      }
    }
  }
}
</script>

<style>
@import '../src/css/font';
* {
  margin: 0;
  padding: 0;
  /* font-family: PingFangSC-Regular;#app· */
}
html,
body,.full{
  height: 100%;
}
body {
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100%;
  background-attachment: fixed;
}

#app {
  position: relative;
  margin: 0 auto;
  padding: 0;
  width: 100%;
  height: 100%;
  min-height: 7.24rem;
  overflow-x: hidden;
  /* overflow-y: scroll; */
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
}

.app_empty {
  font-size: 0.14rem;
  color: #444;
  /* color: rgba(255, 255, 255, 0.5); */
  height: 200px;
  line-height: 200px;
  text-align: center;
}

.gold-bg{ background-color: rgba(255, 193, 14, 1) !important; }
.blue-bg{ background-color: rgba(169, 174, 255, 1) !important; }
.red-bg{ background-color: rgba(255, 94, 94, 1) !important; }
.purple-bg{ background-color: rgba(225, 94, 255, 1) !important; }


.share_item {
  float: left;
  width: 24.9%;
  text-align: center;
}

.share_item img {
  width: 40px;
}

.share_item span {
  display: block;
  text-align: center;
  font-size: 0.1rem;
}

.share_reward_layout {
  margin: 20px 5%;
  overflow: hidden;
  text-align: center;
}

.share_reward {
  float: left;
  text-align: center;
}

.width_50 {
  width: 50%;
}

.width_100 {
  width: 100%;
}

.share_reward img {
  display: block;
  width: 110px;
  margin: 10px auto 0;
}

.share_reward span {
  display: block;
  font-size: 0.14rem;
  color: #ffffff;
  letter-spacing: 1px;
  text-align: center;
  margin: 20px 0 10px;
}

.share_called_layout {
  margin: 5px 5% 20px;
  overflow: hidden;
  text-align: left;
}

.copy {
  display: inline-block;
  width: 20px;
  margin-left: 5px;
}

.share_called {
  position: relative;
  vertical-align: middle;
  margin: 5px auto;
}

.share_called .th {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  padding: 4px 10px 4px 40px;
  margin-bottom: 10px;
}

.share_called .th span {
  display: inline-block;
  font-size: 0.14rem;
  text-align: center;
  width: 50%;
}

.share_called img {
  position: absolute;
  left: 10px;
  width: 40px;
  border-radius: 40px;
  vertical-align: middle;
  display: inline-block;
}

.share_called .userInfo {
  padding: 0 10px 0 40px;
  vertical-align: middle;
  text-align: center;
  line-height: 40px;
}

.share_called .nickname {
  width: 49%;
  display: inline-block;
  font-size: 0.14rem;
}

.share_called .nid {
  width: 49%;
  display: inline-block;
  font-size: 0.14rem;
}

.share_called_empty {
  height: 150px;
  text-align: center;
  line-height: 150px;
  color: rgba(255, 255, 255, 0.5);
}

.share_called_more {
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 10px;
  font-size: 0.14rem;
}

.action_bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 10px 0;
  -webkit-transform: translateZ(0);
  -webkit-overflow-scrolling: touch;
  transform: translate3d(0, 0, 0);
}
.font_normal {
  font-size: 0.16rem !important;
}

.font_big {
  font-size: 0.18rem !important;
}

/* .content {
  margin: 10px 20px;
  line-height: 1.5;
  font-size: 0.14rem;
  letter-spacing: 1px;
  text-align: center;
}

.content_left {
  margin: 10px 25px;
  line-height: 1.5;
  font-size: 0.14rem;
  letter-spacing: 1px;
  text-align: left;
} */

.desc {
  margin: 5px 20px;
  line-height: 1.5;
  font-size: 0.12rem;
  letter-spacing: 1px;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
}

.share_img_layout {
  margin: 20px 5%;
  overflow: hidden;
  text-align: center;
}

.share_img {
  float: left;
  text-align: center;
}

.share_img img {
  display: block;
  width: 100px;
  margin: 10px auto 0;
}

.share_img span {
  display: block;
  font-size: 0.12rem;
  color: #ffffff;
  letter-spacing: 1px;
  text-align: center;
  margin: 20px 0 10px;
}

/* loading */
/* .loading-component {
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  z-index: 9999;
}

.loading-component .loading-box {
  width: 70px;
  height: 70px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 40%;
}

.loading-box .loading-item {
  display: inline-block;
  width: 8px;
  height: 100%;
  background: #f54e31;
  margin-right: 3px;
  animation: loadings 1.2s infinite ease-in-out;
  -webkit-animation: loadings 1.2s infinite ease-in-out;
}

.loading-box .loading-item.loading-item2 {
  animation-delay: -1.1s;
  -webkit-animation-delay: -1.1s;
}

.loading-box .loading-item.loading-item3 {
  animation-delay: -1s;
  -webkit-animation-delay: -1s;
}

.loading-box .loading-item.loading-item4 {
  animation-delay: -0.9s;
  -webkit-animation-delay: -0.9s;
} */
/* loading */
.loading-component {
  width: 3rem;
  height: 3rem;
  position: fixed;
  /* background: rgba(0, 0, 0, 0.6); */
  top: 50%;
  margin-top: -1.5rem;
  left: 50%;
  margin-left: -1.5rem;
  z-index: 9999999;
}

.loading-component .loading-box {
  width: 0.4rem;
  height: 0.4rem;
  position: absolute;
  left: 50%;
  margin-left: -0.2rem;
  top: 40%;
  margin-top: -0.2rem;
} 

.loading-box .loading-item {
  display: inline-block;
  width: 0.08rem;
  height: 0.08rem;
  border-radius: 50%;
  background: #FF2E96;
  margin-right: 0.03rem;
  /* animation: loadings 1.2s infinite ease-in-out;
  -webkit-animation: loadings 1.2s infinite ease-in-out; */
  animation: myfirst 1.2s infinite ease-in-out;
  -webkit-animation: myfirst 1.2s infinite ease-in-out;
}

@keyframes myfirst
{
from {background: #FF2E96;}
to {background: #68638A;}
}

@-moz-keyframes myfirst /* Firefox */
{
from {background: #FF2E96;}
to {background: #68638A;}
}

@-webkit-keyframes myfirst /* Safari 和 Chrome */
{
from {background: #FF2E96;}
to {background: #68638A;}
}

@-o-keyframes myfirst /* Opera */
{
from {background: #FF2E96;}
to {background: #68638A;}
}


.loading-box .loading-item.loading-item2 {
  animation-delay: -0.8s;
  -webkit-animation-delay: -0.8s;
}

.loading-box .loading-item.loading-item3 {
  animation-delay: -0.4s;
  -webkit-animation-delay: -0.4s;
}

.loading-box .loading-item.loading-item4 {
  animation-delay: -0.9s;
  -webkit-animation-delay: -0.9s;
}

.loading-box .loading-item.loading-item5 {
  animation-delay: -0.8s;
  -webkit-animation-delay: -0.8s;
}

.loading-box .loading-item.loading-item6 {
  animation-delay: -0.7s;
  -webkit-animation-delay: -0.7s;
}

@-webkit-keyframes loadings {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.4);
  }
  20% {
    -webkit-transform: scaleY(1);
  }
}

@keyframes loadings {
  0%,
  40%,
  100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
    -webkit-transform: scaleY(1);
  }
}

.tips {
  position: fixed;
  display: none;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  z-index: 9999;
  opacity: 0;
  transition: all 0.5s;
}

.tips.on {
  display: block;
  opacity: 1;
}

/* .tips p {
  min-width: 100px;
  max-width: 300px;
  width: auto;
  padding: 15px 20px;
  display: inline-block;
  background: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  border-radius: 5px;
  margin: 20% auto;
} */
.tips p {
  min-width: 1rem;
  max-width: 3rem;
  width: auto;
  padding: 0.15rem 0.2rem;
  display: inline-block;
  background: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  border-radius: 0.05rem;
  margin: 50% auto;
  font-size: 0.14rem;
}

.show {
  display: inline-block;
}

.hide {
  display: none !important;
}
.dialog {
  position: fixed;
  z-index: 999;
  margin: 0 auto;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  -webkit-transform: translateZ(0);
  -webkit-overflow-scrolling: touch;
  transform: translate3d(0, 0, 0);
}
.dialog-content {
  margin: 80px 40px;
}
.dialog .dialog-tips {
  letter-spacing: 1px;
  line-height: 1.4;
}
.dialog .dialog-action {
  margin: 20px;
  color: #4cbce9;
  font-size: 0.18rem;
}
.row {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue